<template>
    <CicPopup title="New Media List" saveable @blur="$emit('blur')" @input="$emit('save')">
        <ul class="item-form">
            <li class="form-label-first">
                {{ $t('Name') }}
            </li>
            <li>
                <CicTextbox id="list_name" :value="value" :maxlength="255" @input="(val) => $emit('input', val)" />
            </li>
        </ul>
    </CicPopup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'AddMediaList',
        components: {
            CicPopup,
            CicTextbox,
        },
        props: {
            value: {
                type: String,
                required: true,
            },
        },
        emits: ['blur', 'input', 'save'],
    };
</script>
